module.exports = __webpack_public_path__ + "img/pic-immersive-reading.84f4abc.webp";